import { Component, OnDestroy, OnInit } from '@angular/core';
import { from, Subscription } from 'rxjs';
import { Resolver } from '@stoplight/json-ref-resolver';
import { JSONSchema7 } from 'json-schema';
import { SplitButtonElement } from '@app/components/elements/splitbutton/splitbutton.component';
import { ProjectService } from '@app/services/project/project.service';
import { SessionItemData } from '@workflow/services/session-item-data';
import { Router } from '@angular/router';
import { ProjectDto } from '@api/projects/interfaces';
import { projectPages } from '@app/pages/project/projects.routes';
import { MenuService } from '@app/services/menu';
import { ErrorNotificationService } from '@app/services/error-notification/error-notification.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import * as schema from './project-schema.json';

@Component({
	selector: 'app-project-create',
	templateUrl: './project-create.component.html',
	styleUrls:['./project-create.component.scss']
})
export class ProjectCreateComponent implements OnInit, OnDestroy {

	private subscription = new Subscription();

	projectFormID = 'form-create-project';
	data: SessionItemData = new SessionItemData({});
	resolvedSchema: JSONSchema7 = null;


	public projectAddSplitButton: SplitButtonElement = {
		title: 'projects.create',
		icon: 'save',
		type: 'primary',
		buttonType: 'submit',
		attrForm: this.projectFormID,
	};
	public projectCancelSplitButton: SplitButtonElement = {
		title: 'projects.cancel',
		icon: 'x',
		type: 'default',
		callback: () => this.showProjectList(),
	};

	constructor(
		private projectService: ProjectService,
		private router: Router,
		private menuService: MenuService,
		private notification: NzNotificationService,
		private errorNotificationService: ErrorNotificationService,
	) {
	}

	ngOnInit(): void {
		const resolver = new Resolver();
		const resolvePromise = resolver.resolve(schema);
		this.subscription.add(
			from(resolvePromise).subscribe(resolvedSchema => this.resolvedSchema = resolvedSchema.result)
		);
		this.menuService.title = 'actions.new.project';
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	async createNewProject(isFormValid: boolean): Promise<void> {
		if (!isFormValid) {
			return;
		}

		try {
			const project = await this.projectService.createProject(this.data.data.projectInfo as ProjectDto);

			this.notification.success('', 'Projekt ' + project.projectname + ' erfolgreich angelegt');
			this.projectService.refreshProjects();
			this.showProjectList();
		} catch (error) {
			this.errorNotificationService.showErrorNotification(error);
		}
	}

	showProjectList(): void {
		this.router
			.navigate([projectPages.dashboard.base()])
			.catch(console.error);
	}

	setSubmitActive(active: boolean): void {
		this.projectAddSplitButton.disabled = !active;
	}

}
